<div class="text-center">
  <ng-container *ngIf="!msg">
    <h1>
      Down for Maintenance
    </h1>

    <p>
      Please check back soon.
    </p>
  </ng-container>

  <ng-container *ngIf="msg">
    <div [innerHTML]="msg"></div>
  </ng-container>
</div>
